import { encodePaginatableQuery, encodeSortableQuery, PaginatableQuery, Query, SortableQuery } from '@/services/api';
import * as q from '@/services/api/request/query';

export interface GroupQuery extends PaginatableQuery, SortableQuery {
  search: string;
}

export const encodeGroupQuery = (query: GroupQuery): Query => ({
  ...encodePaginatableQuery(query),
  search: q.string(query.search),
  ...encodeSortableQuery(query),
});
